import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { useDropzone } from 'react-dropzone';
/**@returns {File | { preview: string}} */

var makeFileFromUrl = function makeFileFromUrl(url) {
  if (typeof url === 'string') return {
    preview: url
  };
  return url;
};
/**
 * @param {import('../types').FormInputLocalFileProps} props
 */


var useLocalFile = function useLocalFile(_ref) {
  var multi = _ref.multi,
      disableClick = _ref.disableClick,
      disableDrop = _ref.disableDrop,
      onChange = _ref.onChange,
      onAdd = _ref.onAdd,
      preview = _ref.preview,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["multi", "disableClick", "disableDrop", "onChange", "onAdd", "preview", "value"]);

  var objectURLs = React.useRef([]);

  var ensurePreview = function ensurePreview(files) {
    if (preview) {
      //make sure the files have a preview url
      files.map(function (file) {
        if (file.preview) return;
        Object.assign(file, {
          preview: URL.createObjectURL(file)
        });
        objectURLs.current.push(file.preview);
      });
    }
  };

  React.useEffect(function () {
    return function () {
      objectURLs.current.map(URL.revokeObjectURL);
      objectURLs.current = [];
    };
  }, []);

  var _useDropzone = useDropzone(_objectSpread({
    multiple: multi,
    noClick: disableClick,
    noDrag: disableDrop,
    onDrop: function onDrop(acceptedFiles) {
      multi ? onChange(acceptedFiles) : onChange(acceptedFiles[0]);
      ensurePreview(acceptedFiles);
      if (!value && onAdd) onAdd();
    }
  }, rest)),
      acceptedFiles = _useDropzone.acceptedFiles,
      restHook = _objectWithoutProperties(_useDropzone, ["acceptedFiles"]);
  /**@type {File[] | { preview: string}[] } */


  var allFiles = acceptedFiles;

  if (value) {
    var newFiles = [];
    if (multi) newFiles = acceptedFiles || value;else newFiles = [acceptedFiles[0] || value];
    allFiles = newFiles.map(makeFileFromUrl);
  }

  if (preview) ensurePreview(allFiles);
  return _objectSpread({
    acceptedFiles: allFiles
  }, restHook);
};

export default useLocalFile;